import React from 'react';
import { BarcodeScanner } from 'Components/WalletPayment';

const ScanBarcode = () => {
	return <BarcodeScanner />;
};

export default ScanBarcode;
